import { useCallback } from 'react';
import { Resetter, atom, useRecoilState, useResetRecoilState } from 'recoil';
import { MapSearchResult } from 'hooks/useMapSearch/useMapSearch.types';
import { LOCAL_STORAGE_KEY } from './localStorage';

type MapSearchState = {
  results: MapSearchResult[];
  value: MapSearchResult | null;
};

type UseMapSearchState = {
  setSearchResults: (results: MapSearchResult[]) => void;
  setSelectedValue: (value: MapSearchResult | null) => void;
  reset: Resetter;
  results: MapSearchResult[];
  value: MapSearchResult | null;
};

export const DEFAULT_MAP_SEARCH_STATE: MapSearchState = {
  results: [],
  value: null,
};

export const mapSearchStateAtom = atom({
  key: LOCAL_STORAGE_KEY.PLACES_SEARCHBAR,
  default: DEFAULT_MAP_SEARCH_STATE,
});

export const useMapSearchState = (): UseMapSearchState => {
  const resetMapSearchState = useResetRecoilState(mapSearchStateAtom);
  const [mapSearchState, setMapSearchState] =
    useRecoilState(mapSearchStateAtom);

  const setSearchResults = useCallback(
    (results: MapSearchResult[]) => {
      setMapSearchState((prev) => ({ ...prev, results }));
    },
    [setMapSearchState],
  );

  const setSelectedValue = useCallback(
    (value: MapSearchResult | null) => {
      setMapSearchState((prev) => ({ ...prev, value }));
    },
    [setMapSearchState],
  );

  return {
    ...mapSearchState,
    setSearchResults,
    setSelectedValue,
    reset: resetMapSearchState,
  };
};
